module.exports = __webpack_public_path__ + "img/qrCodePlaceholderImage.cb77d870.png";